"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var BannedIcon = function BannedIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M.643 13.678C.603 12.666.58 12.03.57 11.77c-.058-1.44.795-2.505 2.561-3.198 2.65-1.04 10.053-2.493 20.103.206 2.364.454 3.368 1.943 3.16 3.272-.138.886-.262 1.744-.372 2.573-.24 1.035-1.005 1.435-2.293 1.2-1.933-.352-1.288-.265-2.837-.582-1.549-.317-1.397-.448-2.1-2.175-.701-1.726-.278-2.158-2.645-2.254-1.578-.064-3.666-.082-6.265-.054-.918-.045-1.483.5-1.695 1.636-.317 1.703-.707 2.08-2.517 2.43a29.29 29.29 0 0 1-3.464.472C1.204 15.23.683 14.69.643 13.678zM2.236.607l21.557 21.24",
    fill: "none",
    stroke: "#FFF"
  }));
};
BannedIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 27 23"
};
var CallingState = function CallingState(_ref) {
  var className = _ref.className,
    onSubmit = _ref.onSubmit;
  var handleSubmit = function handleSubmit(event) {
    event.preventDefault();
    onSubmit();
  };
  return /*#__PURE__*/_react["default"].createElement(StyledCallingState, {
    className: className,
    onSubmit: handleSubmit
  }, /*#__PURE__*/_react["default"].createElement(StyledContent, null, /*#__PURE__*/_react["default"].createElement(BannedIcon, {
    width: 27
  }), /*#__PURE__*/_react["default"].createElement(StyledInfo, null, /*#__PURE__*/_react["default"].createElement("span", null, "\u0412\u044B \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D\u044B \u0438 \u043D\u0435 \u043C\u043E\u0436\u0435\u0442\u0435 \u043F\u0440\u0438\u043D\u0438\u043C\u0430\u0442\u044C \u0437\u0432\u043E\u043D\u043A\u0438!")), /*#__PURE__*/_react["default"].createElement(StyledAccept, null, "\u0420\u0430\u0437\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u0442\u044C")));
};
CallingState.propTypes = {
  className: _propTypes["default"].string,
  onSubmit: _propTypes["default"].func.isRequired
};
CallingState.defaultProps = {
  className: ''
};
var StyledCallingState = _styledComponents["default"].form.withConfig({
  displayName: "Banned__StyledCallingState",
  componentId: "sc-1skqa6o-0"
})(["background-image:linear-gradient(to left,#e50e5c,#ec8926);height:100%;width:100%;"]);
var StyledContent = _styledComponents["default"].div.withConfig({
  displayName: "Banned__StyledContent",
  componentId: "sc-1skqa6o-1"
})(["align-items:center;display:flex;height:100%;justify-content:center;width:100%;"]);
var StyledInfo = _styledComponents["default"].div.withConfig({
  displayName: "Banned__StyledInfo",
  componentId: "sc-1skqa6o-2"
})(["color:#fff;margin-left:15px;span{font-size:17px;}"]);
var StyledAccept = _styledComponents["default"].button.withConfig({
  displayName: "Banned__StyledAccept",
  componentId: "sc-1skqa6o-3"
})(["background-color:#fff;border:none;border-radius:30px;color:#17181a;cursor:pointer;font-size:14px;font-weight:500;height:40px;padding:0 43px;", " + &{margin-left:24px;}"], StyledInfo);
var _default = exports["default"] = CallingState;